export type TransactionType = 'Dealer Sale' | 'Private Sale' | 'Sales and Lease Back' | 'Capital Raise' | 'Refinance' | 'Balloon Refinance' | 'Internal Re-write';
export type TransactionValue = {internalAccess: boolean, type: TransactionType , name: string} | null;
export const TransactionValueOptions: Exclude<TransactionValue, null>[] = [
  {internalAccess: true, type: 'Internal Re-write', name: 'Internal Re-write'},
  {internalAccess: false, type: 'Dealer Sale', name: 'Dealer Sale' },
  {internalAccess: false, type: 'Private Sale', name: 'Private Sale'},
  {internalAccess: false, type: 'Sales and Lease Back', name: 'Sales and Lease Back'},
  {internalAccess: false, type: 'Capital Raise', name: 'Capital Raise'},
  {internalAccess: false, type: 'Refinance', name: 'Refinance'},
  {internalAccess: false, type: 'Balloon Refinance', name: 'Balloon Refinance'},
];

// A "New" asset may only be financed under these transaction types.
export const NEW_ASSET_ALLOWED_TRANSACTION_TYPES: TransactionType[] = ['Dealer Sale', 'Internal Re-write', 'Sales and Lease Back'];

export const isTransactionTypeAllowedForNewAsset = (transactionType: TransactionType | null | undefined): boolean => {
  return !!transactionType && NEW_ASSET_ALLOWED_TRANSACTION_TYPES.includes(transactionType);
};

// Transaction types only internal staff may select (hidden from external users in the dropdown).
export const INTERNAL_ONLY_TRANSACTION_TYPES: TransactionType[] = TransactionValueOptions
  .filter(o => o.internalAccess)
  .map(o => o.type);

// Allowed transaction types for a "New" asset, scoped to what the current user can actually select.
// External users don't see internal-only options (e.g. Internal Re-write), so they are omitted from
// validation error messaging shown to them.
export const getAllowedTransactionTypesForNewAsset = (isInternal: boolean): TransactionType[] => {
  return isInternal
    ? NEW_ASSET_ALLOWED_TRANSACTION_TYPES
    : NEW_ASSET_ALLOWED_TRANSACTION_TYPES.filter(t => !INTERNAL_ONLY_TRANSACTION_TYPES.includes(t));
};

export type PrivateSaleType = 'Yes' | 'No' | 'Sales and Lease Back' | 'Capital Raise' | 'Refinance' | 'Balloon Refinance' | 'Internal Re-write';

export const TransactionValueOptionsForConsumer: Exclude<TransactionValue, null>[] = [
  {internalAccess: false, type: 'Dealer Sale', name: 'Dealer Sale' },
  {internalAccess: false, type: 'Private Sale', name: 'Private Sale'},
  {internalAccess: false, type: 'Capital Raise', name: 'Capital Raise'},
  {internalAccess: false, type: 'Refinance', name: 'Refinance'},
  {internalAccess: false, type: 'Balloon Refinance', name: 'Balloon Refinance'},
];
